import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScheduleComponent } from './pages/schedule/schedule.component';
import { ConsolidationComponent } from './pages/consolidation/consolidation.component';
import { ProvisionalControlComponent } from './pages/provisional-control/provisional-control.component';
import { CaseComponent } from '../cases/pages/case/case.component';
import { tenantRouteGuard } from '../../tenant-config/tenant-route.guard';

const routes: Routes = [
   {
      path: '',
      redirectTo: 'agenda',
      pathMatch: 'full'
      // Protect all other child routes at one time instead of adding the AuthGuard to each route individually.
      // canActivateChild: [AuthGuard],
   },
   {
      path: 'agenda',
      component: ScheduleComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Agenda', tenantRoute: '/app/gestion/agenda' }
      // Protect all other child routes at one time instead of adding the AuthGuard to each route individually.
      // canActivateChild: [AuthGuard],
   },

   {
      path: 'agenda/:providerId',
      component: ScheduleComponent,
      canActivate: [tenantRouteGuard],
      data: { tenantRoute: '/app/gestion/agenda/:providerId' }
   },

   {
      path: 'consolidacion',
      component: ConsolidationComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Consolidación', tenantRoute: '/app/gestion/consolidacion' }
      // Protect all other child routes at one time instead of adding the AuthGuard to each route individually.
      // canActivateChild: [AuthGuard],
   },
   {
      path: 'control-prestacional',
      component: ProvisionalControlComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Control Prestacional', tenantRoute: '/app/gestion/control-prestacional' }
      // Protect all other child routes at one time instead of adding the AuthGuard to each route individually.
      // canActivateChild: [AuthGuard],
   },
   {
      path: 'control-prestacional/:id',
      component: CaseComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Control Prestacional >:id', tenantRoute: '/app/gestion/control-prestacional/:id' }
      // Protect all other child routes at one time instead of adding the AuthGuard to each route individually.
      // canActivateChild: [AuthGuard],
   },
];

@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule],
})
export class ScheduleRoutingModule { }
